export const NAME = "SURROUNDING";
export const SET_SURROUNDINGID = `${NAME}/SET_SURROUNDINGID`;
export const DELETE_SURROUNDINGID = `${NAME}/DELETE_SURROUNDINGID`;

export function setSurroundingId(id) {
  return {
    type: SET_SURROUNDINGID,
    id
  };
}

export function deleteSurroundingId() {
  return {
    type: DELETE_SURROUNDINGID
  };
}



// WEBPACK FOOTER //
// ./src/redux/surrounding/actions.js